import { gql } from "@apollo/client";

const GENERATE_DISPUTE_NOTES = gql`
  mutation GenerateDisputeNotes($params: GenerateDisputeNotesInput!) {
    generateDisputeNotes(params: $params) {
      note
    }
  }
`;

export default GENERATE_DISPUTE_NOTES;
